import Grid from '@mui/material/Grid';
import { errorMessage } from 'constants/CommonConstants';
import { formRequiredRules } from 'helper';
import React, { useImperativeHandle } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CommonInput } from 'sharedComponents/inputGroup';
import { Lead } from '../LeadGenInterface';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { useDispatch, useSelector } from 'react-redux';
import { postLeadCreation } from 'store/LeadCreationState';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';

const WorkInfo: React.ForwardRefRenderFunction<unknown, StepperFromProps> = (
  { onNext, onBack, isSubmit, mappedData },
  ref
) => {
  // Hooks
  const { t } = useTranslation();

  const hasCalledNextStep = React.useRef(false);

  // Redux
  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();

  const { authenticateClientData } = useSelector((state: RootState) => state.auth) || {};
  const widgetData = authenticateClientData?.data?.widgetData || {};

  // React Hook Form
  const { control, trigger, getValues } = useFormContext();

  // React Hook Form Trigger
  const nextStep = () => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;

    const { currentEmployerName, jobTitle } = getValues();

    const workInfoData: Lead = {
      leadSourceId: widgetData?.leadSourceId,
      isSubmit,
      leadDetails: {
        'Current Employer Name': currentEmployerName,
        'Job Title': jobTitle,
        ...mappedData,
      },
    };

    dispatch(postLeadCreation({ data: workInfoData, leadTypeID: widgetData?.leadTypeId })).then((res) => {
      if (
        res?.payload?.success &&
        (res?.payload?.data?.draftLeadId || res?.payload?.data?._id || res?.payload?.data?.Lead?.leadId)
      ) {
        onNext?.();
      }
    });
  };

  const backStep = () => {
    onBack?.();
  };
  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  return (
    <Grid container justifyContent={{ xs: 'center' }}>
      <Grid item xs={12} lg={8}>
        <h3 className='dy-stepper-form__body__title text-center'>{t('leadGen.workTxt1')}</h3>
        <Grid container justifyContent={{ xs: 'left', sm: 'center' }} rowSpacing={3} columnSpacing={2}>
          <Grid item sm={12} xs={12}>
            <CommonInput
              name='currentEmployerName'
              control={control}
              label={t('leadGen.companyName')}
              placeholder={t('leadGen.enterCompanyName')}
              rules={formRequiredRules(errorMessage(t).companyNameRequired)}
              triggerValidationForField={trigger}
            />
          </Grid>
          <Grid item sm={12} xs={12}>
            <CommonInput
              name='jobTitle'
              control={control}
              label={t('leadGen.jobTitle')}
              placeholder={t('leadGen.enterJobTitle')}
              rules={formRequiredRules(errorMessage(t).jobTitleRequired)}
              triggerValidationForField={trigger}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const WorkInfoStep = React.forwardRef(WorkInfo);

export default WorkInfoStep;
